import React from "react";
import { PasswordResetLinkRequest } from "../../components/PasswordReset/PasswordResetLinkRequest";
import LoginContainer from "../../components/LoginContainer/LoginContainer";

export const PasswordResetLinkRequestWrapper = () => {
  return (
    <LoginContainer>
      <PasswordResetLinkRequest />
    </LoginContainer>
  );
};
